<div class="book-intro-section container">
    <div class="row">
        <button class="go-back-btn" (click)="goToLibrary()"></button>
        <span >Back</span>
    </div>

   

    <div class=" book-section">
        <div class="book-text-panel">

            <div class="book-title">
                <h4>{{title}}</h4>
            </div>

            <div class="book-cover-panel-container">
                <div class="book-cover-panel">
                    <img class="book-intro-overlay" src="./img/book-intro/overlay-book-shadow.png" />
                    <img #coverImageElement class="book-intro-pic" [style.width.px]="coverImageWidth" src="{{coverImage}}" />
                </div>
            </div>
          

        </div>
        <div class="continue-btn">
             <button class="btn  start-btn" (click)="start()"></button>
       </div>
</div>
